import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Product } from '../../integrations/woocommerce/types';

export interface WishlistState {
  items: Product[];
  loading: boolean;
  error: string | null;
}

const initialState: WishlistState = {
  items: [],
  loading: false,
  error: null,
};

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    initializeWishlistRequest(state) {
      state.loading = true;
      state.error = null;
    },
    toggleWishlistRequest(state, _action: PayloadAction<Product>) {
      state.error = null;
    },
    setWishlistItems(state, action: PayloadAction<Product[]>) {
      state.items = action.payload;
      state.loading = false;
      state.error = null;
    },
    wishlistRequestFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initializeWishlistRequest,
  toggleWishlistRequest,
  setWishlistItems,
  wishlistRequestFailure,
} = wishlistSlice.actions;

export const wishlistReducer = wishlistSlice.reducer;
export default wishlistSlice.reducer;
